var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.collections_list") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _c("div", { staticClass: "requestsList" }, [
              _c("div", { staticClass: "mt-0" }, [
                _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      { staticClass: "text-xl-start mb-3" },
                      [
                        _c(
                          "b-col",
                          { attrs: { xl: "6", lg: "9", md: "12", cols: "12" } },
                          [
                            _c(
                              "b-button-group",
                              { staticClass: "mt-3 mt-sm-0" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "px-4",
                                    attrs: {
                                      variant:
                                        _vm.tabName === 1
                                          ? "primary btn-selected"
                                          : "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeTabName(1)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("mandate.unit")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "px-4",
                                    attrs: {
                                      variant:
                                        _vm.tabName === 2
                                          ? "primary btn-selected"
                                          : "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeTabName(2)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("mandate.bulk")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.tabName === 1
                      ? _c("Unit")
                      : _vm.tabName === 2
                      ? _c("Bulk")
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }